import { render, staticRenderFns } from "./SalesDetailPopup.vue?vue&type=template&id=4cae2a30"
import script from "./SalesDetailPopup.vue?vue&type=script&lang=js"
export * from "./SalesDetailPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports